import { punks } from './punks'
const getFilters = () => {
  let types = {}
  let attrs = {}
  punks.map((punk, i) => {
    !types[punk.type] ? types[punk.type] = { title: punk.type, count: 1 } : types[punk.type] = { title: punk.type, count: types[punk.type].count + 1 }
    punk.attributes.map(attr => {
      !attrs[attr] ? attrs[attr] = { title: attr, count: 1 } : attrs[attr] = { title: attr, count: attrs[attr].count + 1 }
    })
  })
  console.log(types)
  console.log(attrs)
}
export const filters = {
  // 'sort': {
  //   'Lowest token id': {
  //     'title': 'Lowest token id',
  //   },
  //   'Highest token id': {
  //     'title': 'Highest token id',
  //   },
  //   'Lowest price': {
  //     'title': 'Lowest price',
  //   },
  //   'Highest price': {
  //     'title': 'Highest price',
  //   },
  //   'Lowest bid': {
  //     'title': 'Lowest bid',
  //   },
  //   'Highest bid': {
  //     'title': 'Highest bid',
  //   },
  //   'Lowest rank': {
  //     'title': 'Lowest rank',
  //   },
  //   'Highest rank': {
  //     'title': 'Highest rank',
  //   },
  // },
  types: {
    "Female": {
      "title": "Female",
      "count": 3840
    },
    "Male": {
      "title": "Male",
      "count": 6039
    },
    "Zombie": {
      "title": "Zombie",
      "count": 88
    },
    "Ape": {
      "title": "Ape",
      "count": 24
    },
    "Alien": {
      "title": "Alien",
      "count": 9
    }
  },
  attributes: {
    "3D Glasses": {
      "title": "3D Glasses",
      "count": 286
    },
    "Bandana": {
      "title": "Bandana",
      "count": 481
    },
    "Beanie": {
      "title": "Beanie",
      "count": 44
    },
    "Big Beard": {
      "title": "Big Beard",
      "count": 146
    },
    "Big Shades": {
      "title": "Big Shades",
      "count": 535
    },
    "Black Lipstick": {
      "title": "Black Lipstick",
      "count": 617
    },
    "Blonde Bob": {
      "title": "Blonde Bob",
      "count": 147
    },
    "Blonde Short": {
      "title": "Blonde Short",
      "count": 129
    },
    "Blue Eye Shadow": {
      "title": "Blue Eye Shadow",
      "count": 266
    },
    "Buck Teeth": {
      "title": "Buck Teeth",
      "count": 78
    },
    "Cap Forward": {
      "title": "Cap Forward",
      "count": 254
    },
    "Cap": {
      "title": "Cap",
      "count": 351
    },
    "Chinstrap": {
      "title": "Chinstrap",
      "count": 282
    },
    "Choker": {
      "title": "Choker",
      "count": 48
    },
    "Cigarette": {
      "title": "Cigarette",
      "count": 961
    },
    "Classic Shades": {
      "title": "Classic Shades",
      "count": 502
    },
    "Clown Eyes Blue": {
      "title": "Clown Eyes Blue",
      "count": 384
    },
    "Clown Eyes Green": {
      "title": "Clown Eyes Green",
      "count": 382
    },
    "Clown Hair Green": {
      "title": "Clown Hair Green",
      "count": 148
    },
    "Clown Nose": {
      "title": "Clown Nose",
      "count": 212
    },
    "Cowboy Hat": {
      "title": "Cowboy Hat",
      "count": 142
    },
    "Crazy Hair": {
      "title": "Crazy Hair",
      "count": 414
    },
    "Dark Hair": {
      "title": "Dark Hair",
      "count": 157
    },
    "Do-rag": {
      "title": "Do-rag",
      "count": 300
    },
    "Earring": {
      "title": "Earring",
      "count": 2459
    },
    "Eye Mask": {
      "title": "Eye Mask",
      "count": 293
    },
    "Eye Patch": {
      "title": "Eye Patch",
      "count": 461
    },
    "Fedora": {
      "title": "Fedora",
      "count": 186
    },
    "Front Beard Dark": {
      "title": "Front Beard Dark",
      "count": 260
    },
    "Front Beard": {
      "title": "Front Beard",
      "count": 273
    },
    "Frown": {
      "title": "Frown",
      "count": 261
    },
    "Frumpy Hair": {
      "title": "Frumpy Hair",
      "count": 442
    },
    "Goat": {
      "title": "Goat",
      "count": 295
    },
    "Gold Chain": {
      "title": "Gold Chain",
      "count": 169
    },
    "Green Eye Shadow": {
      "title": "Green Eye Shadow",
      "count": 271
    },
    "Half Shaved": {
      "title": "Half Shaved",
      "count": 147
    },
    "Handlebars": {
      "title": "Handlebars",
      "count": 263
    },
    "Headband": {
      "title": "Headband",
      "count": 406
    },
    "Hoodie": {
      "title": "Hoodie",
      "count": 259
    },
    "Horned Rim Glasses": {
      "title": "Horned Rim Glasses",
      "count": 535
    },
    "Hot Lipstick": {
      "title": "Hot Lipstick",
      "count": 696
    },
    "Knitted Cap": {
      "title": "Knitted Cap",
      "count": 419
    },
    "Luxurious Beard": {
      "title": "Luxurious Beard",
      "count": 286
    },
    "Medical Mask": {
      "title": "Medical Mask",
      "count": 175
    },
    "Messy Hair": {
      "title": "Messy Hair",
      "count": 460
    },
    "Mohawk Dark": {
      "title": "Mohawk Dark",
      "count": 429
    },
    "Mohawk Thin": {
      "title": "Mohawk Thin",
      "count": 441
    },
    "Mohawk": {
      "title": "Mohawk",
      "count": 441
    },
    "Mole": {
      "title": "Mole",
      "count": 644
    },
    "Mustache": {
      "title": "Mustache",
      "count": 288
    },
    "Muttonchops": {
      "title": "Muttonchops",
      "count": 303
    },
    "Nerd Glasses": {
      "title": "Nerd Glasses",
      "count": 572
    },
    "Normal Beard Black": {
      "title": "Normal Beard Black",
      "count": 289
    },
    "Normal Beard": {
      "title": "Normal Beard",
      "count": 292
    },
    "Orange Side": {
      "title": "Orange Side",
      "count": 68
    },
    "Peak Spike": {
      "title": "Peak Spike",
      "count": 303
    },
    "Pigtails": {
      "title": "Pigtails",
      "count": 94
    },
    "Pilot Helmet": {
      "title": "Pilot Helmet",
      "count": 54
    },
    "Pink With Hat": {
      "title": "Pink With Hat",
      "count": 95
    },
    "Pipe": {
      "title": "Pipe",
      "count": 317
    },
    "Police Cap": {
      "title": "Police Cap",
      "count": 203
    },
    "Purple Eye Shadow": {
      "title": "Purple Eye Shadow",
      "count": 262
    },
    "Purple Hair": {
      "title": "Purple Hair",
      "count": 165
    },
    "Purple Lipstick": {
      "title": "Purple Lipstick",
      "count": 655
    },
    "Red Mohawk": {
      "title": "Red Mohawk",
      "count": 147
    },
    "Regular Shades": {
      "title": "Regular Shades",
      "count": 527
    },
    "Rosy Cheeks": {
      "title": "Rosy Cheeks",
      "count": 128
    },
    "Shadow Beard": {
      "title": "Shadow Beard",
      "count": 526
    },
    "Shaved Head": {
      "title": "Shaved Head",
      "count": 300
    },
    "Silver Chain": {
      "title": "Silver Chain",
      "count": 156
    },
    "Small Shades": {
      "title": "Small Shades",
      "count": 378
    },
    "Smile": {
      "title": "Smile",
      "count": 238
    },
    "Spots": {
      "title": "Spots",
      "count": 124
    },
    "Straight Hair Blonde": {
      "title": "Straight Hair Blonde",
      "count": 144
    },
    "Straight Hair Dark": {
      "title": "Straight Hair Dark",
      "count": 148
    },
    "Straight Hair": {
      "title": "Straight Hair",
      "count": 151
    },
    "Stringy Hair": {
      "title": "Stringy Hair",
      "count": 463
    },
    "Tassle Hat": {
      "title": "Tassle Hat",
      "count": 178
    },
    "Tiara": {
      "title": "Tiara",
      "count": 55
    },
    "Top Hat": {
      "title": "Top Hat",
      "count": 115
    },
    "VR": {
      "title": "VR",
      "count": 332
    },
    "Vampire Hair": {
      "title": "Vampire Hair",
      "count": 147
    },
    "Vape": {
      "title": "Vape",
      "count": 272
    },
    "Welding Goggles": {
      "title": "Welding Goggles",
      "count": 86
    },
    "Wild Blonde": {
      "title": "Wild Blonde",
      "count": 144
    },
    "Wild Hair": {
      "title": "Wild Hair",
      "count": 447
    },
    "Wild White Hair": {
      "title": "Wild White Hair",
      "count": 136
    }
  }
}